module.exports = __webpack_public_path__ + "media/images/contest-label-left-60362091cc4937537992dab467f80746.png";